import React from 'react'

const FooterIcon = ({iconName}) => {
  return (
    <i className={`bi ${iconName} me-2 text-white footer-icon`}></i>
  )
}

export default FooterIcon